export const IMAGEKIT_HOST = "ik.imagekit.io";

export type ImageKitPreset =
  | "navbar"
  | "login"
  | "sidebar"
  | "favicon"
  | "spaceCard"
  | "linkHub";

const IMAGEKIT_TRANSFORMS: Record<ImageKitPreset, string> = {
  navbar: "w-140",
  login: "w-280",
  sidebar: "h-80",
  favicon: "w-32,h-32",
  spaceCard: "w-160,h-160",
  linkHub: "w-280,h-280",
};

/**
 * Returns the ImageKit `tr` transform string for a preset.
 */
export const getImageKitTransform = (preset: ImageKitPreset): string =>
  IMAGEKIT_TRANSFORMS[preset];

/**
 * Applies an ImageKit `tr` query param to a URL when it points to ImageKit.
 * Non-ImageKit URLs are returned unchanged.
 */
export const withImageKitTransform = (
  url: string,
  preset: ImageKitPreset,
): string => {
  if (!url.includes(IMAGEKIT_HOST)) {
    return url;
  }

  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set("tr", getImageKitTransform(preset));
    return parsed.toString();
  } catch {
    return url;
  }
};

/**
 * Builds an ImageKit URL with a preset transform applied via query param.
 */
export const buildImageKitUrl = (
  path: string,
  preset: ImageKitPreset,
): string =>
  withImageKitTransform(
    `https://${IMAGEKIT_HOST}/tercerespacio/tercer-espacio/${path}`,
    preset,
  );
